import React, { useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { FaBars, FaTimes } from "react-icons/fa";

const AdminLayout = ({ children }) => {

  const [sidebarOpen, setSidebarOpen] =
    useState(false);

  return (

    <div className="admin-layout">

      {/* MOBILE MENU BUTTON */}
      <button
        className="mobile-menu-btn"
        onClick={() =>
          setSidebarOpen(true)
        }
      >
        <FaBars />
      </button>

      {/* OVERLAY */}
      {
        sidebarOpen && (
          <div
            className="sidebar-overlay"
            onClick={() =>
              setSidebarOpen(false)
            }
          />
        )
      }

      {/* SIDEBAR */}
      <div
        className={`admin-sidebar-wrapper ${
          sidebarOpen ? "open" : ""
        }`}
      >

        <button
          className="close-sidebar"
          onClick={() =>
            setSidebarOpen(false)
          }
        >
          <FaTimes />
        </button>

        <AdminSidebar />

      </div>

      {/* CONTENT */}
      <div className="admin-content">

        <AdminHeader />

        {children}

      </div>

    </div>
  );
};

export default AdminLayout;